<template>
  <div>
    <v-btn outline :color="this.data.btnColor" @click="openDialog()"
    v-if="data.btnType == 'flat'">
      <v-icon left>
        {{this.info.icon}}
      </v-icon>
      {{this.info.title}}
    </v-btn>
    <v-btn icon :color="this.data.btnColor" @click="openDialog()"
    v-if="data.btnType == 'icon'">
      <v-icon>
        {{this.info.icon}}
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" max-width="500">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor">
              {{this.info.icon}}
            </v-icon>
            <span :class="ui.textHeadline">
              {{this.info.title}}
            </span>
            <v-spacer/>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{this.info.status}}
            </div>
            <v-spacer/>
            <div :class="ui.textSubheading">
              {{this.info.date}} | {{this.info.rev}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-4">
            <div :class="ui.textTitle">
              {{this.info.intro.title}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2"
          v-for="(item, index) in this.info.intro.text" :key="index">
            <div :class="ui.textSubheading">
              {{item}}
            </div>
          </v-layout>
          <div class="mt-4">
            <v-layout row class="text-xs-left ml-3 mr-2 mt-2"
            v-for="(item, index) in this.info.content" :key="index">
              <v-flex xs12>
                <v-layout row class="mt-4">
                  <v-flex xs12>
                    <span :class="ui.textTitle">
                      {{item.title}}
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row class="mt-2">
                  <v-flex xs12>
                    <span :class="ui.textSubheading">
                      {{item.intro}}
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row class="mt-2"
                v-for="(item, index) in item.text" :key="index">
                  <v-flex xs12>
                    <v-layout row class="mt-2">
                      <span :class="ui.textSubheading">
                        {{index + 1}} {{item}}
                      </span>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-spacer/>
          <v-btn
          v-if="this.data.enableAgreeBtn"
          @click="agreeToDocument()" :color="ui.btnColor" flat>
            <v-icon left> check_box_outline_blank </v-icon>
            Agree
          </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dataprivacytext from "@/admin/privacy/mixins/dataprivacytext.js";
import termsandcondtext from "@/admin/tc/mixins/termsandcondtext.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
export default {
  // eslint-disable-next-line
  mixins: [
    adminFunctions,
    docRevsModFunctions,
    apptheme,
    dataprivacytext,
    termsandcondtext
  ],
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      valid: true,
      indeterminateProgressBar: false
    };
  },
  computed: {
    info() {
      let obj = {
        icon: "1"
      };
      if (this.data.type === "DP") {
        obj = this.dp;
      }
      if (this.data.type === "TC") {
        obj = this.tc;
      }
      return obj;
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    },
    agreeToDocument() {
      if (this.data.type === "DP") {
        this.$store.dispatch("changeDataPrivacyAgree", true);
      }
      if (this.data.type === "TC") {
        this.$store.dispatch("changeTermsAndCondAgree", true);
      }
      this.dialog = false;
    }
  }
};
</script>
